<template>
  <GenericTaskCreationStep
    class="task-overview-dialog"
    v-on="$listeners"
    v-bind="$props"
  >
    <template v-slot:title>Task Overview</template>
    <template>
      <v-card class="task-overview-card">
        <v-card-text>
          <v-row
            class="mb-4 task-overview-row"
            v-for="(section, i) in sections"
            :key="i"
          >
            <v-col md="3">
              <b>{{ section.label }}:</b>
            </v-col>
            <v-col md="8">
              <v-chip
                class="task-overview-value"
                v-if="section.value"
                small
                label
                :title="section.value"
              >
                {{ section.value }}
              </v-chip>
            </v-col>
            <v-col md="1">
              <v-icon
                alt="Edit"
                :title="`Edit ${section.label}`"
                right
                color="primary"
                dense
                @click="() => $emit('changeStep', section.step)"
              >
                mdi-circle-edit-outline
              </v-icon>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <div class="d-flex">
      <v-btn
        class="ml-auto my-2"
        color="primary"
        text
        x-small
        @click="() => $emit('changeStep', advancedTaskOptionsSection)"
      >
        Advanced options
      </v-btn>
    </div>
  </GenericTaskCreationStep>
</template>

<style>
.task-overview-dialog {
  width: 600px;
}

.task-overview-row {
  display: flex;
  align-items: center;
  flex-flow: nowrap;
  text-wrap: nowrap;
  height: 28px;
}

.task-overview-card {
  padding: 8px;
}

.task-overview-value {
  & .v-chip__content {
    display: block;
    padding: 2px 5px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>

<script>
import GenericTaskCreationStep from './GenericTaskCreationStep.vue';

import { TaskCreationSteps } from '@/constants/task';

const NONE_LABEL = 'None';

export default {
  name: 'NewTaskOverview',
  components: { GenericTaskCreationStep },
  props: {
    // GenericTaskCreation Props
    nextButtonText: String,
    nextButtonIsLoading: Boolean,
    // NewTaskOverviewProps
    name: String,
    business: Object,
    importSession: Object,
    importRequest: Object,
    // Uploads related data
    recentResultId: [Object, File],
    useRecentResult: Boolean,
    sessionInventoryFilePath: String,
    useSessionInventoryFile: Boolean,
    selectedInputFile: [Object, File],
    selectedInputFileFormat: String,
    selectedHistoryFile: [Object, File],
    selectedPreviousRunFile: [Object, File],
    selectedInventoryFile: [Object, File]
  },
  data() {
    return {
      advancedTaskOptionsSection: TaskCreationSteps.ADVANCED_TASK_OPTIONS,
      sections: [
        {
          label: 'Name',
          value: this.name,
          step: TaskCreationSteps.CREATE_TASK_FOR_BUSINESS
        },
        {
          label: 'Business',
          value: this.business
            ? `${this.business.name} (${this.business.id})`
            : '',
          step: TaskCreationSteps.CREATE_TASK_FOR_BUSINESS
        },
        {
          label: 'Import Session',
          value: this.importSession
            ? `${this.importSession.id} (${this.importSession.type})`
            : '',
          step: TaskCreationSteps.SELECT_TASK_IMPORT_SESSION
        },
        {
          label: 'Import Request',
          value: this.importRequest
            ? `${this.importRequest.id} (${this.importRequest.type})`
            : NONE_LABEL,
          step: TaskCreationSteps.SELECT_TASK_IMPORT_REQUEST
        },
        {
          label: 'Input File',
          value: this.useSessionInventoryFile
            ? this.sessionInventoryFilePath
            : this.selectedInputFile
              ? `${this.selectedInputFile.name} (${this.selectedInputFileFormat})`
              : '',
          step: TaskCreationSteps.UPLOAD_TASK_FILES
        },
        {
          label: 'History File',
          value: this.selectedHistoryFile
            ? this.selectedHistoryFile.name
            : NONE_LABEL,
          step: TaskCreationSteps.UPLOAD_TASK_FILES
        },
        {
          label: 'Previous Run File',
          value: this.selectedPreviousRunFile
            ? this.selectedPreviousRunFile.name
            : NONE_LABEL,
          step: TaskCreationSteps.UPLOAD_TASK_FILES
        },
        {
          label: 'Inventory File',
          value: this.selectedInventoryFile
            ? this.selectedInventoryFile.name
            : NONE_LABEL,
          step: TaskCreationSteps.UPLOAD_TASK_FILES
        }
      ]
    };
  },
  methods: {}
};
</script>
